import script from "./Disclaimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Disclaimer.vue?vue&type=script&setup=true&lang=ts"

import "./Disclaimer.vue?vue&type=style&index=0&id=12b8517d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12b8517d"]])

export default __exports__